<app-ng-material-single-form
        [label]="'Company Reg No'"
        [formField]="'label'"
></app-ng-material-single-form>

